import { useDisclosure } from '@chakra-ui/react';
import { t } from '@lingui/core/macro';
import { Plus } from 'lucide-react';
import { FormModalWrapper } from '@duke-hq/ui/components/Modals/FormModalWrapper';
import { CauseForm } from './CauseForm';
import type { RouterOutputs } from '@duke-hq/svc-api/provider';

type CauseFormModalProps = {
  editCause?: RouterOutputs['groupRewards']['listCausesWithInfiniteScroll']['items'][number];
  isOpen?: boolean;
  onClose?: () => void;
  onApproveCause?: (causeId: string) => void;
  onArchiveCause?: (causeId: string) => void;
  approvingCauseId?: string;
  archivingCauseId?: string;
};

export function CauseFormModal({
  editCause,
  isOpen: externalIsOpen,
  onClose: externalOnClose,
  onApproveCause,
  onArchiveCause,
  approvingCauseId,
  archivingCauseId,
}: CauseFormModalProps) {
  const { isOpen: internalIsOpen, onClose: internalOnClose, onOpen } = useDisclosure();

  // Use external state if provided, otherwise use internal state
  const isOpen = externalIsOpen !== undefined ? externalIsOpen : internalIsOpen;
  const onClose = externalOnClose || internalOnClose;
  const isEditMode = !!editCause;

  return (
    <FormModalWrapper
      modalOpenButtonText={isEditMode ? null : t`Suggest a cause`}
      modalOpenButtonLeftIcon={isEditMode ? undefined : Plus}
      modalContent={
        <CauseForm
          onClose={onClose}
          editCause={editCause}
          onApproveCause={onApproveCause}
          onArchiveCause={onArchiveCause}
          approvingCauseId={approvingCauseId}
          archivingCauseId={archivingCauseId}
        />
      }
      isOpen={isOpen}
      onClose={onClose}
      onOpen={isEditMode ? undefined : onOpen}
      modalContentHeight="auto"
      modalCloseButton={false}
    />
  );
}
